// 新增或修改配置模板数据表
export const formTemplate: any = {
    name: '',
    desc: '',
    tts: {
        max: '',
        threshold: ''
    },
    'asr-rt': {
        max: '',
        threshold: ''
    },
    ocr: {
        max: '',
        threshold: ''
    },
    lpr: {
        max: '',
        threshold: ''
    },
    translate: {
        max: '',
        threshold: ''
    },
    fr: {
        max: '',
        threshold: ''
    },
    faceCompare: {
        max: '',
        threshold: ''
    },
    plantDetect: {
        max: '',
        threshold: ''
    },
    asr: {
        max: '',
        threshold: ''
    },
    animalDetect: {
        max: '',
        threshold: ''
    },
    faceSearch: {
        max: '',
        threshold: ''
    }
};

// 选择纬度
export const aiConfigItem: any = [
    {
        label: '语音合成',
        value: 'tts'
    },
    {
        label: '实时语音识别',
        value: 'asr-rt'
    },
    {
        label: '文字识别',
        value: 'ocr'
    },
    {
        label: '车牌识别',
        value: 'lpr'
    },
    {
        label: '文本翻译',
        value: 'translate'
    },
    {
        label: 'AI人脸属性识别',
        value: 'fr'
    },
    {
        label: '人脸相似度识别',
        value: 'faceCompare'
    },
    {
        label: '植物识别',
        value: 'plantDetect'
    },
    {
        label: '语音识别',
        value: 'asr'
    },
    {
        label: '动物识别',
        value: 'animalDetect'
    },
    {
        label: '人脸比对',
        value: 'faceSearch'
    },
    {
        label: '车票识别',
        value: 'ttr'
    }
];

// AI配置
export const aiConfigObj: any = {
    tts: '语音合成',
    'asr-rt': '实时语音识别',
    ocr: '文字识别',
    lpr: '车牌识别',
    translate: '文本翻译',
    fr: 'AI人脸属性识别',
    faceCompare: '人脸相似度识别',
    plantDetect: '植物识别',
    asr: '语音识别',
    animalDetect: '动物识别',
    faceSearch: '人脸比对',
    ttr: '车票识别',
};

export const frequencyAiTypes = ['asr', 'asr-rt', 'faceCompare', 'fr', 'lpr', 'ocr', 'plantDetect', 'translate', 'tts', 'animalDetect', 'faceSearch', 'ttr'];

export default {
    formTemplate,
    aiConfigItem,
    aiConfigObj,
    frequencyAiTypes
};
